import { useEffect, useState } from "react";
import { blcgallerypagedata } from "../../Blc_Api/BlcGalleryPageData/BlcGalleryPageData";






export function useBlcGalleryPageData() {
       const [galleryData, setGalleryData] = useState();

       useEffect(()=>{

           blcgallerypagedata().then(data=>{

              setGalleryData(data);
           });
       },[]);

       return([galleryData,setGalleryData]);
}